export function getAddressForUrl(displayLineFirst?: string, displayLineLast?: string) {
    return displayLineFirst
        ? `${displayLineFirst}${displayLineLast ? `, ${displayLineLast}` : ''}`.replace(' ', '+')
        : null;
}
